"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ModalDisablePhase = ({ onClickDisablePhase, onCloseModal }) => {
    return (react_1.default.createElement(Modal_1.default, { minWidth: 400, customClass: "w-[400px]", onClose: onCloseModal },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Disable Phase') }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("p", { className: "px-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)('If you disable this phase, all of your configuration will be completely removed. Are you sure?'))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Disable Phase'),
                onClick: onClickDisablePhase,
                dataCy: 'button-primary-modal'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                onClick: onCloseModal,
                dataCy: 'button-secondary-modal'
            }, useBorder: false })));
};
exports.default = ModalDisablePhase;
